import { Component, Vue } from "vue-property-decorator";

@Component
export default class ConfirmDlg extends Vue {
  dialog = false;
  reject = null;
  message = null;
  outputMsg = "";
  title = null;
  resolve = null
  hasTextField = false;
  textFieldLabel = "Note";
  options = {}

  open(title, message, hasTextField, textFieldLabel, options) {
    this.dialog = true;
    this.title = title;
    this.hasTextField = hasTextField;
    this.textFieldLabel = textFieldLabel;
    this.message = message;

    const defaultOptions ={
      color: "#3f51b5",
      width: 605,
      zIndex: 200,
      noconfirm: false,
      noButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.No'],
      yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Yes'],
      isPersistent: false
    };

    this.options = Object.assign(defaultOptions, options);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  agree() {
    this.resolve({ agree: true, message: this.outputMsg });
    this.dialog = false;
  }

  cancel() {
    this.resolve(false);
    this.dialog = false;
  }
}